/* eslint-disable react/jsx-closing-tag-location */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useParams } from 'react-router-dom';
import { html } from './receipt-html';
import { getImagePath } from '../../../utils';
import { translate } from '../../Translate';

const Receipt = ({
  history,
  getReceipts,
  client,
  intl,
}) => {
  const [invoice, setInvoice] = useState();
  const [loaded, setLoaded] = useState(false);
  const [print, setPrint] = useState(false);
  const { invoiceId } = useParams();

  useEffect(() => {
    getReceipts().then(
      (data) => {
        if (data && data.body && data.body.length < 1) {
          console.error('Invoice not found, please contact support');
          history.goBack();
        } else {
          setInvoice(data && data.body.data.find((invoice) => invoice.orderId === invoiceId));
        }
      }
    );
  }, []);

  useEffect(() => { print && setTimeout(() => { window.print() }, 3000); }, [print])

  useEffect(() => {
    const config = require(`../../../../public/clients/${client}/config.json`);
    const logoImg = getImagePath('logo-invoice.png', client);
    if (invoice) {
      html.__html = html.__html
        .replace(`{{client}}`, client)
        .replaceAll(`{{accountNumber}}`, 'XXXXXXXXXXXXX')
        .replace(`{{planName}}`, invoice.title)
        .replace(`{{subtitle}}`, translate(intl, 'Receipt.subtitle'))
        .replace(`{{entityTitle}}`, translate(intl, `Receipt.entityTitle.${invoice.paymentInfo?.type}`))
        .replace(`{{entity}}`, invoice.paymentInfo?.entity)
        .replace(`{{referenceTitle}}`, translate(intl, `Receipt.referenceTitle`))
        .replaceAll(`{{reference}}`, invoice.paymentInfo?.reference)
        .replace(`{{beneficiaryTitle}}`, translate(intl, `Receipt.beneficiaryTitle`))
        .replaceAll(`{{beneficiary}}`, invoice.paymentInfo?.beneficiary)
        .replaceAll(`{{accountTitle}}`, translate(intl, `Receipt.accountTitle`))

        .replace(`{{amount}}`, invoice.amount)
        .replace(`{{currency}}`, invoice.currency)
        .replaceAll(`{{mailContact}}`, config.email ? config.email : '-')
        .replace(`{{orderLabel}}`, config.orderColor)
        .replaceAll(`{{amountLabel}}`, config.amountColor)
        .replaceAll(`{{planLabel}}`, config.planColor)
        .replace(`{{emailLabel}}`, config.emailColor)
        .replace(`{{clientLogo}}`, logoImg)
      setLoaded(true);
      setPrint(true);
    }
  }, [invoice]);

  return (
    loaded && (
      <div
        dangerouslySetInnerHTML={html}
        className="bodyInvoice"
        style={{ margin: '2%' }}
      />
    )
  );
};

Receipt.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
  }).isRequired,
  getReceipts: PropTypes.func.isRequired,
  client: PropTypes.string
};

export default Receipt;
